<script>
export default {
  data() {
    return {
    }
  },
}
</script>
<template>
  <div>
    <h1>相關問答</h1>
  </div>
</template>
